// Critical entry for the owned sctmgUtils runtime.
// Responsibilities:
//   1. Boot the shell (sidebar + content container) immediately.
//   2. Hand control to the owned runtime so it resolves the initial route.
//   3. Load only the changelog chunk for the default route.
//
// The entry MUST stay small and free of deferred vendor imports.
// Vendors are loaded on demand by their owning feature module via
// dynamic import().

import { bootShell, initialiseAuth, mountInitialRoute, setLanguage } from './runtime.js';
import { setupLanguageSelector } from './i18n.js';

const root = document.getElementById('app-root') || document.body;
bootShell(root);
void initialiseAuth(root);
const initialLanguage = setupLanguageSelector();

Promise.resolve(setLanguage(initialLanguage)).then(() => mountInitialRoute(root)).catch((error) => {
  console.error('[sctmgUtils] failed to mount initial route', error);
  const fallback = document.createElement('div');
  fallback.setAttribute('role', 'alert');
  fallback.className = 'sctmg-fatal-error';
  fallback.textContent = 'No se pudo cargar la pantalla inicial.';
  root.appendChild(fallback);
});
